var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_383_10905)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.807143,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5319 11.0928C33.7761 11.0928 34.7848 12.1015 34.7848 13.3457C34.7848 13.4049 34.7825 13.4641 34.7778 13.5231L33.7273 26.8227C33.678 27.4464 33.1575 27.9274 32.5319 27.9274C31.9062 27.9274 31.3857 27.4464 31.3365 26.8227L30.2859 13.5231C30.1879 12.2827 31.1141 11.1977 32.3545 11.0998C32.4135 11.0951 32.4727 11.0928 32.5319 11.0928Z",
    fill: "#743D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4219 23.4307L53.3751 23.4025C46.6432 19.3679 38.3649 20.141 32.5411 24.7243C26.7174 20.141 18.4391 19.3679 11.7072 23.4025L11.6604 23.4307C11.6532 23.4245 11.6507 23.4261 11.6481 23.4276C10.4355 24.1566 11.3741 26.2128 12.738 26.5891C12.8409 26.6175 12.9436 26.6478 13.0462 26.6799C17.8631 28.1896 20.5442 33.3183 19.0345 38.1353C18.384 40.211 17.0613 41.8902 15.3812 43.0082C14.5024 43.593 14.1295 44.8062 14.4659 45.8067C14.9409 47.2196 14.99 48.79 14.5101 50.3212C13.9581 52.0825 12.8016 53.4871 11.3406 54.3781C10.4143 54.9431 9.90595 56.1561 10.465 57.0859L10.8809 57.7778C15.4246 65.3205 24.5282 68.4336 32.5411 65.7081C40.5541 68.4336 49.6577 65.3205 54.2013 57.7778L59.7037 48.6255C64.9374 39.9372 62.127 28.6537 53.4341 23.4276C53.4316 23.4261 53.429 23.4245 53.4219 23.4307Z",
    fill: "#FF4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4946 38.893C50.1667 38.893 53.1435 35.9178 53.1435 32.2478C53.1435 28.5777 50.1667 25.6025 46.4946 25.6025C42.8225 25.6025 39.8457 28.5777 39.8457 32.2478C39.8457 35.9178 42.8225 38.893 46.4946 38.893Z",
    fill: "#FF7878"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6013 3.66796C52.8126 2.82272 45.0312 3.55509 41.092 7.32279C37.1527 11.0905 35.7469 18.9182 36.4406 19.6617C37.1344 20.4053 45.0207 19.6617 49.0807 15.885C53.1408 12.1082 54.3899 4.51321 53.6013 3.66796Z",
    fill: "#5ABB1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.046 54.1651C50.1269 54.1651 51.8137 52.4791 51.8137 50.3994C51.8137 48.3197 50.1269 46.6338 48.046 46.6338C45.9652 46.6338 44.2783 48.3197 44.2783 50.3994C44.2783 52.4791 45.9652 54.1651 48.046 54.1651Z",
    fill: "#EA2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5053 60.3689C43.9741 60.3689 45.1648 59.1789 45.1648 57.7108C45.1648 56.2428 43.9741 55.0527 42.5053 55.0527C41.0364 55.0527 39.8457 56.2428 39.8457 57.7108C39.8457 59.1789 41.0364 60.3689 42.5053 60.3689Z",
    fill: "#EA2B2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_383_10905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(0 0.476562)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApple);
export default __webpack_public_path__ + "static/media/icon-apple.f2dc8b15d645c6b6b7e59f9eb13dffba.svg";
export { ForwardRef as ReactComponent };